export default class FromAddress {
  name!: string | null;

  constructor() {
    this.name = null;
  }
}
